/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ZohoServiceDeskIncidentManagementConfiguration {
    getFixupPrototypeFunction() { return ZohoServiceDeskIncidentManagementConfiguration.fixupPrototype; }

    static newInstance(model: Partial<ZohoServiceDeskIncidentManagementConfiguration>): ZohoServiceDeskIncidentManagementConfiguration {
        let obj = Object.assign(new ZohoServiceDeskIncidentManagementConfiguration(), model);
        ZohoServiceDeskIncidentManagementConfiguration.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ZohoServiceDeskIncidentManagementConfiguration>): ZohoServiceDeskIncidentManagementConfiguration {
        if (!model) return null;
        return ZohoServiceDeskIncidentManagementConfiguration.newInstance(<ZohoServiceDeskIncidentManagementConfiguration> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ZohoServiceDeskIncidentManagementConfiguration) {
        if (!obj) return;

        models.ZohoServiceDeskIncidentManagementConfiguration.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ZohoServiceDeskIncidentManagementConfiguration): boolean {
        Object.setPrototypeOf(obj, ZohoServiceDeskIncidentManagementConfiguration.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.requester) {
            models.ZohoServiceDeskIncidentManagementConfigurationRequester.fixupPrototype(this.requester);
        }
        if (this.site) {
            models.ZohoServiceDeskSite.fixupPrototype(this.site);
        }
    }

    /**
     * Module for Incident management
     */
    module: models.ZohoServiceDeskModule;

    requester: models.ZohoServiceDeskIncidentManagementConfigurationRequester;

    /**
     * Assignee of the Incident
     */
    assignee: string;

    /**
     * Sites for Incident management
     */
    site: models.ZohoServiceDeskSite;

}
